module.exports = __webpack_public_path__ + "img/bbc-radio-3.369b7bdb.png";